/* Fashion CITY — 상단 메뉴 앤커 스크롤
   브라우저 기본 smooth 스크롤은 띠(마퀴) 애니메이션과 충돌해서
   멈춰버립니다. 그래서 직접 애니메이션을 돕니다. */
(function () {
  function headerOffset() {
    var hd = document.querySelector('.fcx-hd');
    return (hd ? hd.getBoundingClientRect().height : 78) + 20;
  }

  function reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animateTo(y, dur) {
    var start = window.pageYOffset;
    var diff = y - start;
    if (Math.abs(diff) < 2) return;
    if (reduceMotion()) { window.scrollTo(0, y); return; }

    var t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      // easeInOutQuad
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      window.scrollTo(0, Math.round(start + diff * e));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function scrollToTarget(target, push) {
    var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    if (y < 0) y = 0;
    var dist = Math.abs(y - window.pageYOffset);
    var dur = Math.min(900, Math.max(400, dist * 0.4));
    animateTo(y, dur);
    if (push && target.id) {
      try { history.replaceState(null, '', '#' + target.id); } catch (e) {}
    }
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href === '#' || href.indexOf('#') === -1) return;

    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.pathname !== location.pathname || !url.hash || url.hash.length < 2) return;

    var target;
    try { target = document.querySelector(url.hash); } catch (err) { return; }
    if (!target) return;

    e.preventDefault();
    e.stopPropagation();

    var toggle = document.getElementById('fcx-toggle');
    if (toggle && toggle.checked) toggle.checked = false;

    scrollToTarget(target, true);
  }, true);

  // 다른 페이지에서 #해시를 달고 들어온 경우 — 고정 헤더 높이만큼 보정
  function onLoadHash() {
    if (!location.hash || location.hash.length < 2) return;
    var target;
    try { target = document.querySelector(location.hash); } catch (e) { return; }
    if (!target) return;
    setTimeout(function () {
      var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo(0, y < 0 ? 0 : y);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoadHash);
  } else {
    onLoadHash();
  }
  window.addEventListener('load', onLoadHash);
})();
